module.exports = __webpack_public_path__ + "img/customer-nope.9ff86d19.svg";